module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/vi_3-ad5ca7f71d777f6c94f9eb4110db13e0.jpg";